<template>
  <div class="report--responses check-list-phone auto-list_col_centered">
    <div class="state-num">
      <p>{{ responseAuto ? responseAuto.state_numbers : 'Нет данных' }}</p>
      <p>
        {{ responseAuto ? responseAuto.state_numbers_trailer : 'Нет данных' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateNumbers',
  props: {
    responseAuto: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
.report--responses
  .state-num
    p
      font-size: 14px
      margin: 10px 0
</style>
